import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LOGO_URL } from '../../lib/constants';
import { BookButton, WhatsappButton } from './CtaButtons';

const StickyCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 560);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-cta"
          initial={{ y: -70, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -70, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed top-0 left-0 right-0 z-50 border-b border-gold/25 bg-white/95 backdrop-blur-xl shadow-[0_8px_30px_-18px_rgba(92,22,22,0.45)]"
        >
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-2.5 md:px-8">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Omvedha" className="h-9 w-auto" />
              <span className="hidden font-serif text-sm text-gold-deep sm:block">
                Gurupurnima Sai Baba Mahotsava
              </span>
            </div>
            <div className="flex items-center gap-2.5">
              <BookButton label="sticky" size="sm" />
              <WhatsappButton label="sticky" size="sm" />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
